var React = require('react');

function DocsIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"28","cy":"28","r":"28","fill":"#242A35","key":0}),React.createElement("path",{"d":"M40 32.375V16.625C40 15.1752 38.8002 14 37.3214 14H20.3571C17.3984 14 15 16.3505 15 19.25V36.75C15 39.6495 17.3984 42 20.3571 42H38.2143C39.2003 42 40 41.2163 40 40.2992C40 39.6583 39.6313 39.1223 39.1071 38.8172V34.3678C39.654 33.8406 40 33.1516 40 32.375ZM36.4286 38.5H20.3571C19.3711 38.5 18.5714 37.7163 18.5714 36.75C18.5714 35.7837 19.3711 35 20.3571 35H36.4286V38.5Z","fill":"white","key":1})]);
}

DocsIcon.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none"};

module.exports = DocsIcon;

DocsIcon.default = DocsIcon;
